<template>
    <div class="list-view bookmark-listing">
        <template v-for="(item, index) in bookmarkState.bookmarkedPages" :key="index">
            <a class="item"
               href="#"
               @click.prevent="gotoBookmarkedPage(item)"
            >
                <span class="label">{{ bookData.pagenames[item] }}</span>
                <delete-bookmark-btn v-show="bookmarkState.isEditing"
                                     :index="index"
                >
                </delete-bookmark-btn>
            </a>

        </template>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import config from "@/config/config.json";
    import cssvar from '@/scss/_variables.scss';
    import DeleteBookmarkBtn from "@/views/reader/bookmark/DeleteBookmarkBtn";
    import {useBookmark}  from "@/modules/reader/bookmark/bookmark";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";

    export default {
        components: {
            DeleteBookmarkBtn
        },
        setup(props, context) {

            const { bookData} = useDataLoader();
            const {bookmarkState,deleteBookmark,gotoBookmarkedPage} = useBookmark();
            const { bookInfoState} = useBookInfo();

            return {
                bookData,
                bookInfoState,
                bookmarkState,
                deleteBookmark,
                gotoBookmarkedPage
            }
        }

    }

</script>

<style scoped lang="scss">

    .list-view {

        .item {

            display:flex;
            @include transition(background, .2s);

            .label {
                margin-right:auto;
            }

            border-bottom: 1px solid $border-color-lightest;
            padding:10px;

            &:hover {
                background:$color-ui-active;
            }
        }
    }

</style>

